module.exports = __webpack_public_path__ + "static/media/dark-motion-constellation-optimisation.85abef1.mp4";